module.exports = "https://cdn.realtymogul.com/static/media/graph_strategies.29f3b3bb.png";